exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#single[data-v-0916db43]{background:#1f1f1f}", ""]);

// exports
